<div class="mt-2">
    <h2 class="text-2xl font-extrabold tracking-tight leading-7 sm:leading-10 truncate flex items-center">
        <ng-content></ng-content>
    </h2>
</div>